import { isBookableScheduleStaff } from 'features/Home/Book/Booking/Schedule/PatientSchedule/ScheduleCalendar/scheduleInstance'
import type { IPatientConsultationStaff } from 'features/Home/interfaces/IInfoPatient'

// Doctors and providers, plus whoever an existing appointment is already booked with.
export const appointmentProviders = (
  staffs: IPatientConsultationStaff[],
  bookedStaffId?: number | null,
): IPatientConsultationStaff[] =>
  staffs.filter((staff) => isBookableScheduleStaff(staff) || staff.id === bookedStaffId)
